// ask_user: the agent asks the clinician to pick between a few options, shown
// as buttons in the chat (with a "Something else" box), the way Claude does,
// instead of making them type an answer. Not tied to the note: any chat with
// tools gets it.

export const MAX_OPTIONS = 6;

export const askUserTool = {
  name: 'ask_user',
  description:
    "Ask the clinician to choose between a few clear options, shown as buttons they can click (they can also type something else). Use it when you need a decision you can't make yourself: which section, which side, whether a change goes in just this note, the saved instructions or both, which of two readings of their request. Give 2 to 6 short options taken from what you have actually read (real section titles, real values), with the one you'd recommend first. Don't add an 'Other' option: they can always type something else. Their choice comes back as the answer.",
  parameters: {
    type: 'object',
    properties: {
      question: { type: 'string', description: 'The question, in one short sentence' },
      options: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            label: { type: 'string', description: 'What the button says, a few words' },
            description: { type: 'string', description: 'Optional one-line detail' },
          },
          required: ['label'],
        },
        description: `2 to ${MAX_OPTIONS} options`,
      },
    },
    required: ['question', 'options'],
  },
  handler: async ({ question, options }, ctx) => {
    if (typeof question !== 'string' || !question.trim()) return { ok: false, error: 'question is empty' };
    const clean = (Array.isArray(options) ? options : [])
      .map((option) => (typeof option === 'string' ? { label: option } : option))
      .filter((option) => option && typeof option.label === 'string' && option.label.trim())
      .map((option) => ({
        label: option.label.trim().slice(0, 80),
        ...(typeof option.description === 'string' && option.description.trim() && { description: option.description.trim().slice(0, 160) }),
      }))
      .filter((option, index, all) => all.findIndex((other) => other.label === option.label) === index);
    if (clean.length < 2 || clean.length > MAX_OPTIONS) {
      return { ok: false, error: `Give 2 to ${MAX_OPTIONS} options.` };
    }
    if (!ctx.askUser) return { ok: false, error: 'Ask in words instead; buttons are not available here.' };
    const reply = await ctx.askUser({ question: question.trim(), options: clean });
    if (!reply || reply.cancelled) return { ok: false, cancelled: true, error: 'The clinician did not answer.' };
    return {
      ok: true,
      answer: reply.answer,
      choseOption: Boolean(reply.choseOption),
      // Kept with the chat (not shown as a change) so later turns know what was decided
      action: { status: 'answered', summary: `Asked "${question.trim().slice(0, 160)}": ${String(reply.answer).slice(0, 300)}` },
    };
  },
};
